import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import Button from "components/Button";
import Layout from "components/layout";

const Page = styled.div`
  margin: 20vh auto 0 auto;
  padding: 0 8px;
  max-width: 1024px;
  height: 70vh;
`;

const Heading = styled.h2`
  font-family: ${props => props.theme.fonts.subheading};
  margin-bottom: 4px;
  text-transform: none;
`;

const Text = styled.div`
  font-size: 1.1em;
`;

const Message = styled.div`
  margin-bottom: 32px;
`;

export default function ErrorPage({ clearError }) {
  return (
    <Layout hidden={true}>
      <Page>
        <Message>
          <Heading>Not Found</Heading>
          <Text>It's looks like you're lost</Text>
        </Message>
        <Link onClick={clearError} to="/">
          <Button>Back To Landing Page</Button>
        </Link>
      </Page>
    </Layout>
  );
}

ErrorPage.propTypes = {
  clearError: PropTypes.func,
};
